import { VDRFileView } from '../../../slices/marketplace/data-room/models/vdr-file-view.model';
import { VDRFileSourceType } from '../../../slices/marketplace/data-room/models/vdr-file-source-type.enum';

export enum VDRFileStatus {
    Approved = 'Approved',
    UnderReviewUpload = 'Under Review (Upload)',
    UnderReviewRemoval = 'Under Review (Removal)',
}

export const getFileStatus = (file: VDRFileView): VDRFileStatus => {
    if (file.fileSourceType === VDRFileSourceType.VDR && !file.isUploadApproved) {
        return VDRFileStatus.UnderReviewUpload;
    }

    if (file.isHiddenForExternalSourcesRequested && !file.isHiddenForExternalSources) {
        return VDRFileStatus.UnderReviewRemoval;
    }

    return VDRFileStatus.Approved;
};

export const getFileId = (file: VDRFileView): number => {
    if (file.fileSourceType === VDRFileSourceType.VDR) {
        return file.vdrFileId!;
    }
    return file.sourceAnswerFileId!;
};

export const isPendingUploadApproval = (file: VDRFileView): boolean => {
    return file.fileSourceType === VDRFileSourceType.VDR && !file.isUploadApproved;
};

export const isPendingRemovalApproval = (file: VDRFileView): boolean => {
    return file.isHiddenForExternalSourcesRequested && !file.isHiddenForExternalSources;
};

export const isApprovedFile = (file: VDRFileView): boolean => {
    const isUploadApproved = file.fileSourceType === VDRFileSourceType.DataRequest || file.isUploadApproved;
    return isUploadApproved && !file.isHiddenForExternalSourcesRequested;
};

